module.exports = __webpack_public_path__ + "static/media/fire-attack.66e85f2a.mp3";